import {createTheme} from '@mui/material/styles';


const HEADERS_FONT = 'Lato, Roboto';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3a84aa'
    },
    secondary: {
      main: '#ff6d00'
    },
    borderColor: {
      main: '#e0e0e0'
    },
    white: {
      main: '#ffffff'
    },
    iconColor: {
      main: 'rgba(0, 0, 0, 0.54)'
    },
    secondaryTextColor: {
      main: '#4f4f4f'
    },
    primaryBackground: {
      main: '#ecf7fd'
    },
  },
  variables: {
    appBarHeight: '56px',
    appBarZIndex: '1200',
    drawerWidth: '200px',
    headersFont: HEADERS_FONT
  }
});

export default theme;
